var $e01b4013a471f6b5$exports = {};
$e01b4013a471f6b5$exports = {
    "collapse": `Zbali\u{165}`,
    "expand": `Rozbali\u{165}`
};


export {$e01b4013a471f6b5$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
